<template>
  <form @submit.prevent="handleSubmit(item)" novalidate>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.name) }">
      <label for="_name" class="control-label">Nazwa</label>
      <input v-model="item.name" type="text" id="_name" class="form-control" />
      <span v-if="errors && errors.name" class="help-block" id="_name_helpBlock">{{ errors.name }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.nip) }">
      <label for="_nip" class="control-label">NIP</label>
      <input v-model="item.nip" type="text" id="_nip" class="form-control" />
      <span v-if="errors && errors.nip" class="help-block" id="_nip_helpBlock">{{ errors.nip }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.regon) }">
      <label for="_regon" class="control-label">REGON</label>
      <input v-model="item.regon" type="text" id="_regon" class="form-control" />
      <span v-if="errors && errors.regon" class="help-block" id="_regon_helpBlock">{{ errors.regon }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.krs) }">
      <label for="_krs" class="control-label">KRS</label>
      <input v-model="item.krs" type="text" id="_krs" class="form-control" />
      <span v-if="errors && errors.krs" class="help-block" id="_krs_helpBlock">{{ errors.krs }}</span>
    </div>
      <div :class="{ 'form-group': true, 'has-error': (errors && errors.address && errors.address.street) }">
      <label for="_address_street" class="control-label">Ulica</label>
      <input v-model="item.address.street" type="text" id="_address_street" class="form-control" />
      <span v-if="errors && errors.address && errors.address.street" class="help-block" id="_address_street_helpBlock">{{ errors.address.street }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.address && errors.address.number) }">
      <label for="_address_number" class="control-label">Numer domu</label>
      <input v-model="item.address.number" type="text" id="_address_number" class="form-control" />
      <span v-if="errors && errors.address && errors.address.number" class="help-block" id="_address_number_helpBlock">{{ errors.address.number }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.address && errors.address.postalCode) }">
      <label for="_address_postalCode" class="control-label">Kod pocztowy</label>
      <input v-model="item.address.postalCode" type="text" id="_address_postalCode" class="form-control" />
      <span v-if="errors && errors.address && errors.address.postalCode" class="help-block" id="_address_postalCode_helpBlock">{{ errors.address.postalCode }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.address && errors.address.city) }">
      <label for="_address_city" class="control-label">Miasto</label>
      <input v-model="item.address.city" type="text" id="_address_city" class="form-control" />
      <span v-if="errors && errors.address && errors.address.city" class="help-block" id="_address_city_helpBlock">{{ errors.address.city }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.bankAccount && (errors.bankAccount.numberPLN || errors.bankAccount.bankAccountSet)) }">
      <label for="_bankAccount_numberPLN" class="control-label">Numer konta bankowego (PLN)</label>
      <input v-model="item.bankAccount.numberPLN" type="text" id="_bankAccount_numberPLN" class="form-control" />
      <span v-if="errors && errors.bankAccount && errors.bankAccount.numberPLN" class="help-block" id="_bankAccount_numberPLN_helpBlock">{{ errors.bankAccount.numberPLN }}</span>
      <span v-if="errors && errors.bankAccount && errors.bankAccount.bankAccountSet" class="help-block" id="_bankAccount_number_helpBlock">{{ errors.bankAccount.bankAccountSet }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.bankAccount && (errors.bankAccount.numberEUR || errors.bankAccount.bankAccountSet)) }">
      <label for="_bankAccount_numberEUR" class="control-label">Numer konta bankowego (EUR)</label>
      <input v-model="item.bankAccount.numberEUR" type="text" id="_bankAccount_numberEUR" class="form-control" />
      <span v-if="errors && errors.bankAccount && errors.bankAccount.numberEUR" class="help-block" id="_bankAccount_numberEUR_helpBlock">{{ errors.bankAccount.numberEUR }}</span>
      <span v-if="errors && errors.bankAccount && errors.bankAccount.bankAccountSet" class="help-block" id="_bankAccount_number2_helpBlock">{{ errors.bankAccount.bankAccountSet }}</span>
    </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.phone) }">
      <label for="_address_city" class="control-label">Telefon</label>
      <input v-model="item.phone" type="text" id="_phone" class="form-control" />
      <span v-if="errors && errors.phone" class="help-block" id="_phone_helpBlock">{{ errors.phone }}</span>
    </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.website) }">
      <label for="_website" class="control-label">Strona WWW</label>
      <input v-model="item.website" type="text" id="_website" class="form-control" />
      <span v-if="errors && errors.website" class="help-block" id="_website_helpBlock">{{ errors.website }}</span>
    </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.email) }">
      <label for="_email" class="control-label">E-mail</label>
      <input v-model="item.email" type="text" id="_email" class="form-control" />
      <span v-if="errors && errors.email" class="help-block" id="_email_helpBlock">{{ errors.email }}</span>
    </div>
      <div :class="{ 'form-group': true, 'has-error': (errors && errors.summary) }">
      <label for="_summary" class="control-label">Podsumowanie</label>
      <textarea v-model="item.summary" id="_summary" class="form-control"></textarea>
      <span v-if="errors && errors.summary" class="help-block" id="_summary_helpBlock">{{ errors.summary }}</span>
    </div>

    <router-link :to="{ name: 'CompanyShow' }" class="btn btn-primary"><span>Powrót</span><svg-icon name="back"/></router-link>
    <my-button text="Zapisz" icon="tick" type="submit" />
  </form>
</template>

<script>
  export default {
    props: {
      handleSubmit: {
        type: Function,
        required: true,
      },
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object
      },
      initialValues: {
        type: Object
      }
    },
    computed: {
      item: function () {
        return this.initialValues ? this.initialValues : this.values;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Form.vue?d9d34a14